import { collection, doc, serverTimestamp, WriteBatch, Transaction } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { AdminAction } from '@/lib/types';

const AUDIT_COLLECTION = 'admin_audit_log';

export function logAdminActionAtomic(
  writer: WriteBatch | Transaction,
  action: AdminAction,
  userId: string,
  details: Record<string, any> = {},
  gameId: string | null = null,
  previousState: Record<string, any> | null = null
): void {
  const auditRef = doc(collection(db, AUDIT_COLLECTION));
  
  const data = {
    action,
    game_id: gameId,
    user_id: userId,
    details,
    previous_state: previousState,
    timestamp: serverTimestamp(),
  };

  if ('commit' in writer) {
    writer.set(auditRef, data);
  } else {
    writer.set(auditRef, data);
  }
}
